import type { ITooltipTheme } from '@visactor/vchart';

export const tooltip: ITooltipTheme = {
  offset: {
    x: 10,
    y: 10
  },
  panel: {
    padding: {
      top: 10,
      left: 10,
      right: 10,
      bottom: 10
    }
  },
  spaceRow: 6,
  titleLabel: {
    spacing: 0
  },
  shape: {
    size: 8,
    spacing: 6
  },
  keyLabel: {
    spacing: 26
  },
  valueLabel: {
    spacing: 0
  }
};
